import type {AuthUser} from './types'

export function isAdmin(user: Pick<AuthUser, 'role'> | null | undefined): boolean {
    return user?.role === 'admin'
}
